import {
    paramDsName,
    paramListName,
    paramSiteUrl,
} from '../constants/parameterNames';
import { typeDataSource } from '../constants/parameterTypes';
import { failure, success } from '../helpers/commandResult';
import { getParamValue } from '../helpers/parameter.accessors';
import {
    getDataConnection,
    verifyDataConnectionExists,
} from '../helpers/qRules.dataConnection.helpers';

const optionalParameters = [
    {
        name: paramDsName,
        description: `The data connection to the GetListCollection method of the Lists web service - either this or /${paramSiteUrl} is required.`,
        type: typeDataSource,
    },
    {
        name: paramSiteUrl,
        description: `Site url where the specified list exists  - either this or /${paramDsName} is required.`,
    },
];

const requiredParameters = [
    {
        name: paramListName,
        description: 'The name of the list to return the GUID for',
    },
];

const description = 'Returns the GUID for the list named in /listname.';

function getSiteUrlFromDataSource(dataConnections, dsName) {
    verifyDataConnectionExists(dataConnections, dsName);

    const listConn = getDataConnection(dataConnections, dsName);
    const connUrl = listConn.getUrl();

    // BUGBUG - This is case sensitive
    return connUrl.replace('_vti_bin/Lists.asmx', '');
}

async function executeAsync({ dataConnections, parameters, sharePointAccess }) {
    const dsName = getParamValue(parameters, paramDsName);
    const specifiedSiteUrl = getParamValue(parameters, paramSiteUrl);
    const listName = getParamValue(parameters, paramListName);

    if (!dsName && !specifiedSiteUrl) {
        return failure(
            `Either /${paramDsName} or /${paramSiteUrl} must be specified.`,
        );
    }

    const siteUrl =
        specifiedSiteUrl || getSiteUrlFromDataSource(dataConnections, dsName);

    try {
        const listId = await sharePointAccess.getListIdByNameAsync(
            siteUrl,
            listName,
        );

        return success(listId);
    } catch (e) {
        return failure(`Failed to get GUID for list: ${e.message || listName}`);
    }
}

const GetListGuid = {
    description,
    optionalParameters,
    requiredParameters,
    executeAsync,
};

export default GetListGuid;
